// // import React, { useEffect, useState } from 'react';
// // import { getDashboardStats } from '../../../services/reporterService'; // <-- apna actual path daal do jaha getDashboardStats export ki hai
// // import './ReporterDashboard.css';

// // const STATUS_LABELS = {
// //   live: 'Live',
// //   posted: 'Posted',
// //   pending_approval: 'Pending',
// //   draft: 'Draft',
// //   rejected: 'Rejected',
// // };

// // const ReporterDashboard = () => {
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState('');
// //   const [stats, setStats] = useState(null);
// //   const [recentNews, setRecentNews] = useState([]);
// //   const [topNews, setTopNews] = useState([]);

// //   useEffect(() => {
// //     fetchStats();
// //   }, []);

// //   const fetchStats = async () => {
// //     setLoading(true);
// //     setError('');
// //     try {
// //       const data = await getDashboardStats();
// //       setStats(data.stats);
// //       setRecentNews(data.recentNews || []);
// //       setTopNews(data.topNews || []);
// //     } catch (err) {
// //       setError('Dashboard data load nahi ho paaya. Dobara try karein.');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   if (loading) {
// //     return (
// //       <div className="rd-container">
// //         <div className="rd-loader">Dashboard load ho raha hai...</div>
// //       </div>
// //     );
// //   }

// //   if (error) {
// //     return (
// //       <div className="rd-container">
// //         <div className="rd-error">
// //           {error}
// //           <button className="rd-retry-btn" onClick={fetchStats}>Retry</button>
// //         </div>
// //       </div>
// //     );
// //   }

// //   const cards = [
// //     { label: 'Total News', value: stats.totalNews, color: '#4f46e5', icon: '📰' },
// //     { label: 'Total Views', value: stats.totalViews, color: '#0891b2', icon: '👁️' },
// //     { label: 'Total Likes', value: stats.totalLikes, color: '#e11d48', icon: '❤️' },
// //     { label: 'Total Comments', value: stats.totalComments, color: '#d97706', icon: '💬' },
// //     { label: 'Shares Generated', value: stats.totalSharesGenerated, color: '#059669', icon: '🔗' },
// //   ];

// //   const statusBreakdown = [
// //     { key: 'live', value: stats.liveCount },
// //     { key: 'posted', value: stats.postedCount },
// //     { key: 'pending_approval', value: stats.pendingCount },
// //     { key: 'draft', value: stats.draftCount },
// //     { key: 'rejected', value: stats.rejectedCount },
// //   ];

// //   return (
// //     <div className="rd-container">
// //       <h2 className="rd-title">Reporter Dashboard</h2>
// //       <p className="rd-subtitle">Aapki news ki performance ek nazar me</p>

// //       {/* Stat Cards */}
// //       <div className="rd-cards-grid">
// //         {cards.map((card) => (
// //           <div className="rd-card" key={card.label} style={{ borderTopColor: card.color }}>
// //             <div className="rd-card-icon">{card.icon}</div>
// //             <div className="rd-card-value">{card.value?.toLocaleString('en-IN') ?? 0}</div>
// //             <div className="rd-card-label">{card.label}</div>
// //           </div>
// //         ))}
// //       </div>

// //       {/* Status Breakdown */}
// //       <div className="rd-section">
// //         <h3 className="rd-section-title">Status ke hisaab se News</h3>
// //         <div className="rd-status-grid">
// //           {statusBreakdown.map((s) => (
// //             <div className="rd-status-pill" key={s.key}>
// //               <span className="rd-status-dot" data-status={s.key} />
// //               {STATUS_LABELS[s.key]}: <strong>{s.value}</strong>
// //             </div>
// //           ))}
// //         </div>
// //       </div>

// //       <div className="rd-two-col">
// //         {/* Recent News */}
// //         <div className="rd-section">
// //           <h3 className="rd-section-title">Recent News</h3>
// //           {recentNews.length === 0 ? (
// //             <p className="rd-empty">Abhi tak koi news nahi hai</p>
// //           ) : (
// //             <table className="rd-table">
// //               <thead>
// //                 <tr>
// //                   <th>Title</th>
// //                   <th>Status</th>
// //                   <th>Views</th>
// //                   <th>Likes</th>
// //                   <th>Comments</th>
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {recentNews.map((n) => (
// //                   <tr key={n._id}>

// //                     <td  className="rd-td-title" dangerouslySetInnerHTML={{ __html: n.title || "-" }} />
// //                     {/* <td className="rd-td-title">{n.title}</td> */}
// //                     <td>
// //                       <span className={`rd-badge rd-badge-${n.status}`}>
// //                         {STATUS_LABELS[n.status] || n.status}
// //                       </span>
// //                     </td>
// //                     <td>{n.views}</td>
// //                     <td>{n.likes}</td>
// //                     <td>{n.comments}</td>
// //                   </tr>
// //                 ))}
// //               </tbody>
// //             </table>
// //           )}
// //         </div>

// //         {/* Top News by Views */}
// //         <div className="rd-section">
// //           <h3 className="rd-section-title">Top News (By Views)</h3>
// //           {topNews.length === 0 ? (
// //             <p className="rd-empty">Data available nahi hai</p>
// //           ) : (
// //             <ul className="rd-top-list">
// //               {topNews.map((n, idx) => (
// //                 <li key={n._id} className="rd-top-item">
// //                   <span className="rd-top-rank">#{idx + 1}</span>
// //                   <span className="rd-top-title">{n.title}</span>
// //                   <span className="rd-top-views">{n.views} views</span>
// //                 </li>
// //               ))}
// //             </ul>
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default ReporterDashboard;

// import React from 'react';

// const ReporterDashboard = () => {
  
//   // Click karne par bas alert aayega, page change nahi hoga
//   const handleStay = (feature) => {
//     alert(`${feature} module par abhi kaam chal raha hai.`);
//   };

//   const styles = {
//     container: {
//       padding: '40px',
//       fontFamily: 'sans-serif',
//       backgroundColor: '#f4f4f4',
//       minHeight: '90vh',
//       color: '#333'
//     },
//     header: {
//       marginBottom: '40px',
//       borderBottom: '2px solid #ddd',
//       paddingBottom: '10px'
//     },
//     grid: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
//       gap: '20px'
//     },
//     card: {
//       backgroundColor: '#fff',
//       padding: '30px',
//       borderRadius: '8px',
//       boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
//       cursor: 'pointer',
//       textAlign: 'center',
//       border: '1px solid #eee'
//     },
//     icon: {
//       fontSize: '40px',
//       marginBottom: '10px',
//       display: 'block'
//     },
//     title: {
//       fontSize: '20px',
//       fontWeight: 'bold',
//       margin: '10px 0'
//     },
//     status: {
//       fontSize: '12px',
//       color: '#ffa500',
//       fontWeight: 'bold',
//       textTransform: 'uppercase'
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.header}>
//         <h1>Reporter Control Panel</h1>
//         <p>Welcome to your management dashboard. Monitoring system active.</p>
//       </div>

//       <div style={styles.grid}>
//         {/* Card 1 */}
//         <div style={styles.card} onClick={() => handleStay('Story Builder')}>
//           <span style={styles.icon}>📝</span>
//           <div style={styles.title}>Create New Story</div>
//           <span style={styles.status}>Work in Progress</span>
//         </div>

//         {/* Card 2 */}
//         <div style={styles.card} onClick={() => handleStay('Shorts/Reels')}>
//           <span style={styles.icon}>📱</span>
//           <div style={styles.title}>My Shorts & Reels</div>
//           <span style={styles.status}>Under Review</span>
//         </div>

//         {/* Card 3 */}
//         <div style={styles.card} onClick={() => handleStay('Video Manager')}>
//           <span style={styles.icon}>🎬</span>
//           <div style={styles.title}>Video Management</div>
//           <span style={styles.status}>Upcoming</span>
//         </div>

//         {/* Card 4 */}
//         <div style={styles.card} onClick={() => handleStay('Analytics')}>
//           <span style={styles.icon}>📊</span>
//           <div style={styles.title}>View Analytics</div>
//           <span style={styles.status}>Coming Soon</span>
//         </div>
//       </div>

//       <div style={{marginTop: '50px', textAlign: 'center', color: '#888'}}>
//         <p>© 2024 EMS Reporter System | v1.0.0 (Beta)</p>
//       </div>
//     </div>
//   );
// };

// export default ReporterDashboard;

import React from 'react';

const ReporterDashboard = () => {
  
  // Professional Alert Message
  const handleStay = (feature) => {
    alert(`Access Notification: The ${feature} module is currently in the development phase and will be available in the next system update.`);
  };

  const styles = {
    container: {
      padding: '40px',
      fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      backgroundColor: '#f9fafb',
      minHeight: '100vh',
      color: '#111827'
    },
    header: {
      marginBottom: '40px',
      borderBottom: '1px solid #e5e7eb',
      paddingBottom: '20px'
    },
    title: {
      fontSize: '28px',
      fontWeight: '700',
      color: '#1f2937',
      margin: '0'
    },
    subtitle: {
      fontSize: '14px',
      color: '#6b7280',
      marginTop: '5px'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '25px'
    },
    card: {
      backgroundColor: '#ffffff',
      padding: '35px 25px',
      borderRadius: '12px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      cursor: 'pointer',
      textAlign: 'center',
      border: '1px solid #e5e7eb',
      transition: 'all 0.2s ease-in-out'
    },
    icon: {
      fontSize: '42px',
      marginBottom: '15px',
      display: 'block'
    },
    cardTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#374151',
      marginBottom: '8px'
    },
    statusBadge: {
      fontSize: '11px',
      color: '#065f46',
      backgroundColor: '#d1fae5',
      padding: '4px 12px',
      borderRadius: '50px',
      fontWeight: '700',
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    },
    footer: {
      marginTop: '60px',
      textAlign: 'center',
      color: '#9ca3af',
      fontSize: '13px'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Reporter Management Console</h1>
        <p style={styles.subtitle}>System Status: Operational | Authorized Access Only</p>
      </div>

      <div style={styles.grid}>
        {/* Module 1 */}
        <div 
          style={styles.card} 
          onClick={() => handleStay('Story Builder')}
          onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
        >
          <span style={styles.icon}>📝</span>
          <div style={styles.cardTitle}>Editorial Story Builder</div>
          <span style={styles.statusBadge}>In Development</span>
        </div>

        {/* Module 2 */}
        <div 
          style={styles.card} 
          onClick={() => handleStay('Shorts Engine')}
          onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
        >
          <span style={styles.icon}>📱</span>
          <div style={styles.cardTitle}>Shorts & Reels Studio</div>
          <span style={{...styles.statusBadge, backgroundColor: '#fef3c7', color: '#92400e'}}>Under Review</span>
        </div>

        {/* Module 3 */}
        <div 
          style={styles.card} 
          onClick={() => handleStay('Video Assets')}
          onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
        >
          <span style={styles.icon}>🎬</span>
          <div style={styles.cardTitle}>Video Asset Management</div>
          <span style={{...styles.statusBadge, backgroundColor: '#e0e7ff', color: '#3730a3'}}>Scheduled</span>
        </div>

        {/* Module 4 */}
        <div 
          style={styles.card} 
          onClick={() => handleStay('Analytics Suite')}
          onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
        >
          <span style={styles.icon}>📊</span>
          <div style={styles.cardTitle}>Performance Analytics</div>
          <span style={{...styles.statusBadge, backgroundColor: '#f3f4f6', color: '#374151'}}>Upcoming</span>
        </div>
      </div>

      <div style={styles.footer}>
        <p>© 2025 EMS Enterprise Solutions | Editorial Dashboard v2.1.0-beta</p>
      </div>
    </div>
  );
};

export default ReporterDashboard;